import { render } from "./VerticalSpacer.vue?vue&type=template&id=22334d6a"
import script from "./VerticalSpacer.vue?vue&type=script&lang=js"
export * from "./VerticalSpacer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__